var Button = {

  ua: navigator.userAgent.toLowerCase(),

  init:function () {
    var isMSIE = (this.ua.indexOf('msie') > -1) && (ua.indexOf('opera') == -1);
    var isIE11 = (this.ua.indexOf('trident/7') > -1);
    var isIE = isMSIE || isIE11;
    if(isIE) {
      console.log('ie');
      if ($('.m-btn-more-01')[0]) {
        $('.m-btn-more-01').addClass('is-ie');
      }
      if ($('.m-btn-more-02')[0]) {
        $('.m-btn-more-02').addClass('is-ie');
      }
    }
  },
};



module.exports = Button;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_btn.js
// module id = 2
// module chunks = 0